import { useEffect, useRef, useState } from "react";
import MultiDropdown, {
	MultiDropdownProps,
} from "../MultiDropdown/MultiDropdown";
import { DropdownOptions } from "../FormFields/DropdownField";

const AutoFillDropdown = (props: AutoFillDropdownProps) => {
	const [searchValue, setSearchValue] = useState<string>("");
	const [options, setOptions] = useState<DropdownOptions[]>([]);
	const requestId = useRef(0);

	useEffect(() => {
		const currentRequestId = ++requestId.current;
		if (!searchValue) {
			setOptions([]);
			return;
		}

		const timeoutId = window.setTimeout(async () => {
			try {
				const autoFillOptions = await props.autoFill(searchValue);
				if (requestId.current === currentRequestId) {
					setOptions(autoFillOptions ?? []);
				}
			} catch {
				if (requestId.current === currentRequestId) setOptions([]);
			}
		}, props.debounceMs ?? 0);

		return () => window.clearTimeout(timeoutId);
		// The latest callback is intentionally used when the debounced search runs.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchValue, props.debounceMs]);

	return (
		<MultiDropdown
			{...props}
			hideCheckbox
			singleSelect
			onSearch={(value) => {
				setSearchValue(value);
				props.onSearchChange?.(value);
			}}
			options={options}
		/>
	);
};

export default AutoFillDropdown;

interface AutoFillDropdownProps
	extends Omit<MultiDropdownProps, "options" | "onSearch"> {
	autoFill(searchValue: string): Promise<DropdownOptions[]>;
	onSearchChange?(searchValue: string): void;
	debounceMs?: number;
}
